import delegateAPI from '../delegate-api'

import { CONTEXT } from '../../../constants'
import { resolveProperty } from '../../../core/configuration'

export const methods = [
  'dispatchEvent',
  'delegate',
  'registerDelegate',
  'addEventListener',
]

export default function contextPublicApiFactory(fronthubInstance) {
  const privateApi = delegateAPI(fronthubInstance)
  const asPublic = resolveProperty(fronthubInstance)

  return methods.reduce(
    (acc, cur) => ({
      ...acc,
      [cur]: privateApi[cur],
    }),
    {
      services: asPublic('services', false),
      context: asPublic('context', false),
      events: asPublic('events', false),
      mfeDependencies: asPublic('mfeDependencies', false),
      rbac: asPublic('rbac', true),
      features: asPublic('features', true),
      instrumentation: asPublic('instrumentation', false),
      [CONTEXT]: fronthubInstance,
    },
  )
}
